export default "__VITE_ASSET__DNJOYWVj__"